import { createFileRoute } from "@tanstack/react-router";
import AdminTrendingPage from "@/admin/pages/trending";

export const Route = createFileRoute("/admin/trending")({
  component: AdminTrendingPage,
});
